import { tw } from '@/utils/tw';
import ScrollArticleLabelTheme from 'base/components/ScrollArticleLabel/theme';

const ScrollArticleLabel = tw.theme({
  extend: ScrollArticleLabelTheme,
  base: `before:bg-gray-900 after:bg-gray-900`,
});

export default ScrollArticleLabel;
